import React from 'react';
import { createRoot } from 'react-dom/client'
import HomepageGallery from "./Components/HomepageGallery";

const HomePageHeroElement = document.getElementById('homepageHero');
const root = createRoot(HomePageHeroElement);

root.render(<HomepageGallery />);